import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin } from 'lucide-react';
import { profileData, companyInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="dark-content-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section">
            <img 
              src={profileData.logo} 
              alt="Videre Scire" 
              className="footer-logo"
            />
            <p className="footer-tagline">{companyInfo.tagline}</p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <nav className="footer-nav">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/about" className="footer-link">About</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/experience" className="footer-link">Experience</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3 className="footer-heading">Contact</h3>
            <div className="footer-contact">
              <a href={`mailto:${profileData.email}`} className="footer-contact-item">
                <Mail size={18} />
                <span>{profileData.email}</span>
              </a>
              <a href={`tel:${profileData.phone}`} className="footer-contact-item">
                <Phone size={18} />
                <span>{profileData.phone}</span>
              </a>
              <a 
                href={profileData.linkedin} 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-contact-item"
              >
                <Linkedin size={18} />
                <span>LinkedIn</span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Videre Scire Management Consulting Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
